import { App } from "antd";

export function useNotify() {
  const { notification } = App.useApp();

  return {
    success: (msg: string) =>
      notification.success({ title: "موفق", description: msg }),

    error: (msg: string) =>
      notification.error({ title: "خطا", description: msg }),

    info: (msg: string) =>
      notification.info({ title: "توجه", description: msg }),
  };
}
